export class UserContextTreeParametersDto {
    includeGlobalNode = false;
    includeTerminated = false;
    clearCache = true;

    getQueryString(): string {
        const tokens = [];
        tokens.push(`includeGlobalNode=${this.includeGlobalNode}`);
        tokens.push(`includeTerminated=${this.includeTerminated}`);
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
